import { render, staticRenderFns } from "./EditVideoSidebar.vue?vue&type=template&id=7bd53fbe&scoped=true&"
import script from "./EditVideoSidebar.vue?vue&type=script&lang=js&"
export * from "./EditVideoSidebar.vue?vue&type=script&lang=js&"
import style0 from "./EditVideoSidebar.vue?vue&type=style&index=0&id=7bd53fbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd53fbe",
  null
  
)

export default component.exports